import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import YesNoDialog from '../components/YesNoDialog';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import ActivityService from '../services/ActivityService';
import ActivityEditDialog from './ActivityEditDialog';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import { withRouter } from "react-router-dom";

class ActivityListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new ActivityService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            dialogVisibile: false,
            deleteConfirmDialogVisible: false,
            element: this.initNewElement(),
            typeOfUseOptions: []
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
        this.extraWorkEnabled = this.authService.getProfile().extraWorkEnabled;
        this.allowMyTimeInPortal = this.authService.getProfile().allowMyTimeInPortal;

    }

    initNewElement(){
        return {
                name: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywna'},
                useForExtraWorks: false,
                useForTimeReporting: false,
        }
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.login,          
            status: criteria.status,
            typeOfUse: criteria.typeOfUse,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',            
            status: {enumValue: 'ACTIVE', label: 'Aktywna'},
            typeOfUse: null,
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('ActivityStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
            this.enumService
            .getEnumList('ProjectActivityUseForType')
            .then((typeOfUseOptions) =>
                this.setState({
                    typeOfUseOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={'Nazwa'}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />                
               
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={'Status'}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />
                {this.extraWorkEnabled && this.allowMyTimeInPortal ? (
                    <CriteriaDropdownComponent
                        id='typeOfUse-sc'
                        name='typeOfUse'
                        showClear
                        label={'Używaj dla'}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.typeOfUse}
                        options={this.state.typeOfUseOptions}
                        placeholder='Wszystkie'
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        optionLabel='label'
                        filterOptionValue='enumValue'
                        refreshFromBackend
                    />
                ) : null}
            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const href = `${detailUrl}/${rowData?.id}`;
        return (
            <span>
            <ActionLink
                id='activity-list-edit-btn'
                iconName='mdi-pencil'
                iconSide='left'
                iconSize='icon-large'
                handleClick={(e) => this.handleOpenEditDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           <ActionLink
                id='activity-list-delete-btn'
                iconName='mdi-delete'
                iconSide='left'
                iconSize='icon-large'
                handleClick={(e) => this.handleOpenDeleteDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'delete-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           </span>
        );
    }

    handleOpenEditDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: this.cloneElement(rowData), dialogViewMode: 'EDIT'});
    }

    handleOpenDeleteDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({deleteConfirmDialogVisible: true, element: rowData, dialogViewMode: 'DELETE'});
    }

    prepareColumns() {
        const result = [
            {field: 'name', header: 'Nazwa', sortable: true},                        
            {field: 'status', header: 'Status', sortable: true, body: this.enumTemplate.bind(this, 'status')}            
        ];
        if (this.extraWorkEnabled && this.allowMyTimeInPortal) {
            result.push({field: 'useForExtraWorks', header: 'Używana do prac dodatkowych', sortable: true, body: this.checkboxTemplate.bind(this, 'useForExtraWorks')});
            result.push({field: 'useForTimeReporting', header: 'Używana do raportowania czasu', sortable: true, body: this.checkboxTemplate.bind(this, 'useForTimeReporting')});
        }
        if (this.authService.isUserInRole('ROLE_PROJECT_ACTIVITY_EDIT')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            })
        }
        return result;
    }

    checkboxTemplate(field, rowData){
        let value = rowData[field];
        return <div style={{ marginLeft:"80px", color:"#274e82"}}>
            <InputCheckboxComponent
            id={`activity-${field}`}
            value={value}
            viewMode={'EDIT'}
            insideTable={true}
            labelOnRight={true}
            disabled={true}
        />  
        </div> 
            

       
    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_PROJECT_ACTIVITY_EDIT')
            ? [
                  {   id: 'newActivityBtn',
                      label: t('activity.newButton'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleOpenNewDialog,
                  },
              ]
            : [];
    }
    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();       
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW'});
    }

    handleDelete(e){
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.element)              
        this.service
            .remove(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('activity.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('activity.deleteError'));               
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({deleteConfirmDialogVisible: false});
            });
        
    }

    afterObjectUpdate() {       
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid activity-list'>
                <BreadcrumbsItem to='/activity-list'>{'Podwykonawcy'}</BreadcrumbsItem>
                {this.renderView()}
                {this.state.dialogVisibile ? (
                    <ActivityEditDialog
                        id='activity-edit-dialog'
                        className='activity-dialog'
                        key={`activity-dialog-${this.state.element?.id}`}
                        activityUseVisible={this.extraWorkEnabled && this.allowMyTimeInPortal}
                        element={this.state.element}
                        onHide={(e) => this.setState({dialogVisibile: false})}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}                        
                        afterSave={(e) => {
                            this.setState({dialogVisibile: false});
                           this.afterObjectUpdate();
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                {this.state.deleteConfirmDialogVisible ? (
                <YesNoDialog
                id={'activity-delete-confirmation-dialog'}
                visible={this.state.deleteConfirmDialogVisible}
                header={t('activity.deleteHeader')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                       
                        this.handleDelete();
                    } else {
                        this.setState({deleteConfirmDialogVisible: false})
                    }
                }}
                onHide={() => this.setState({deleteConfirmDialogVisible: false})}
                //dialogViewMode = {this.state.dialogViewMode}
            >
               {t('details.deleteConfirmation')+'\n' + this.state.element.name}
            </YesNoDialog> 
                ) : null}
            </div>
        );
    }
}

ActivityListContainer.defaultProps = {
    detailUrl: '/#/activity/details',
    newUrl: '/#/activity/create',
    lazy: true,
};

ActivityListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(ActivityListContainer);
